import * as React from "react";
import styled from "styled-components";

import { MainProps } from "../index";
import EmptyPage from "./components/ErrorPage";
import resizer from "utils/browser/resizer";
import MobileHeader from "views/components/MwebHeader";
import MegatronFrontForMobile from "./components/MegatronFrontForMobile";
import { NewPageTips } from "views/pc";
import { px2rem } from "../utils/css";
import { isLocalDevelop } from "utils/debug";
import { Platform } from "utils/runtime";
import { onChangeHeaderLang } from "utils/language";

const MainContainer = styled.section`
	min-height: calc(600px - 3.0625rem);
	width: 100%;
	max-width: 100vw;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	row-gap: ${px2rem(12)};

	/* 兼容iponeX */
	@supports (bottom: constant(safe-area-inset-bottom)) {
		padding-bottom: calc(3.0625rem + constant(safe-area-inset-bottom));
	}

	@supports (bottom: env(safe-area-inset-bottom)) {
		padding-bottom: calc(3.0625rem + env(safe-area-inset-bottom));
	}
`;

interface MobileState {
	hasDownloadBanner: boolean;
}

class Mobile extends React.Component<MainProps, MobileState> {
	state: MobileState = {
		hasDownloadBanner: false,
	};

	constructor(props: MainProps) {
		super(props);
	}
	componentDidMount() {
		resizer();
		window.addEventListener("resize", this.onResizeHandler);
	}

	onResizeHandler = () => {
		resizer();
	};

	render() {
		const { page, runtime, modules } = this.props;
		if (!page) {
			return <EmptyPage language={runtime.languageCode} />;
		}

		return [
            <React.Fragment key={"MHEADER"}>
				{!runtime?.isInApp && (
					<MobileHeader
						isUat={runtime.isUat}
						isDev={isLocalDevelop(runtime.hostname)}
						cookies={runtime.cookies || {}}
						runtime={{
							languageCode: runtime.languageCode,
							currency: runtime.currency,
							countryCode: runtime.countryCode3,
							countryCode2: runtime.countryCode2,
							platform: Platform.MWEB,
							sid: runtime.sid,
							countryId: runtime.countryId,
						}}
						onChangeLanguage={onChangeHeaderLang}
					/>
				)}
			</React.Fragment>,
			<React.Fragment>{runtime.isUat && <NewPageTips />}</React.Fragment>,
			<MainContainer
				key={"PAGE"}
				style={{
					backgroundColor: modules.length === 0 ? "#fff" : page?.ui?.bgColor || "#f7f7f7",
				}}
			>
				<MegatronFrontForMobile {...this.props} />
			</MainContainer>,
		];
	}
}

export default Mobile;
